import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Sparkles } from "lucide-react";

const MESSAGES = [
  "Livraison offerte dès 25 € d'achat",
  "-16 % sur le Pack Rituel · offre du moment",
  "Code BIENVENUE10 : -10 % sur votre première commande",
];

const PromoBanner = () => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setIndex((i) => (i + 1) % MESSAGES.length), 4000);
    return () => clearInterval(t);
  }, []);

  return (
    <div data-testid="promo-banner" className="fixed top-0 left-0 right-0 z-[60] h-9 bg-terracotta text-cream flex items-center justify-center overflow-hidden">
      <AnimatePresence mode="wait">
        <motion.p
          key={index}
          initial={{ y: 14, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: -14, opacity: 0 }}
          transition={{ duration: 0.45, ease: [0.16, 1, 0.3, 1] }}
          className="flex items-center gap-2 text-[11px] sm:text-xs font-mono tracking-widest uppercase"
        >
          <Sparkles size={12} className="shrink-0" />
          {MESSAGES[index]}
        </motion.p>
      </AnimatePresence>
    </div>
  );
};

export default PromoBanner;
